import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { FormBuilder, NG_VALUE_ACCESSOR, UntypedFormGroup } from '@angular/forms';
import { DayOfWeek } from 'generated/graphql-types';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DaysOfWeekReportParameterValue } from '../models/day-of-week-report-parameter-value';
import { DaysOfWeekParameterFormModel } from '../report-parameter-list/models/report-parameter-form-value';
import { ReportParameterConfig } from '../report-parameter-list/report-parameter.config';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ multi: true, provide: NG_VALUE_ACCESSOR, useExisting: DaysOfWeekReportParameterComponent }],
    selector: 'ndt-days-of-week-report-parameter',
    templateUrl: './days-of-week-report-parameter.component.html',
    standalone: false
})
export class DaysOfWeekReportParameterComponent implements OnDestroy {
   daysOfWeek = [
      DayOfWeek.Monday,
      DayOfWeek.Tuesday,
      DayOfWeek.Wednesday,
      DayOfWeek.Thursday,
      DayOfWeek.Friday,
      DayOfWeek.Saturday,
      DayOfWeek.Sunday,
   ];

   config: ReportParameterConfig;

   set form(form: UntypedFormGroup) {
      this._form = form;
      const formValue: DaysOfWeekParameterFormModel = this.form.value;
      if (formValue) {
         this.initializeContentFormValue(formValue);
      }
   }

   get form(): UntypedFormGroup {
      return this._form;
   }

   get label() {
      return this.config?.label;
   }

   private _form: UntypedFormGroup;

   destroyed$ = new Subject<void>();

   constructor(public fb: FormBuilder) {}

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   private initializeContentFormValue(formValue: DaysOfWeekReportParameterValue): void {
      for (const day of this.daysOfWeek) {
         this.form.addControl(day, this.fb.control(true));
      }
      this.form.patchValue({ ...formValue });
      this.form.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe((formValue) => {
         this.form.patchValue({ values: this.getDayValues(formValue) }, { emitEvent: false });
      });
   }

   private getDayValues(formValue: any): DayOfWeek[] {
      const dayValues: DayOfWeek[] = [];
      for (const day of this.daysOfWeek) {
         if (formValue[day]) {
            dayValues.push(day);
         }
      }
      return dayValues;
   }
}
